import React from 'react';
import styles from '../../styles/LoadingSpinner.module.css';

const LoadingSpinner: React.FC = () => {
    return (
        <div className={styles.app_loading}>
            <div className={styles.loading_card}>
                <div className={styles.spinner} />
                <div className={styles.loading_title}>Loading your account...</div>
                <div className={styles.loading_subtitle}>
                    Please wait while we prepare everything for you.
                </div>
            </div>
        </div>
    )
}

export default LoadingSpinner;